<div>
  <div class="header" style="margin-bottom: 2rem;">
    <p class="dialog-title">
      <strong>How would you like to pay {{brandName}}?</strong>
    </p>
  </div>

  <button class="btn btn-fs offset-md-1 col-md-10 btn-greengo" (click)="buttonClicked('2')" style="margin-bottom: 1.4rem;" npFocusOutClicked>
    Instant Payment
    <img src="./assets/images/icon-png/icon-info-white.svg" alt="" [title]="instantPaymentTooltip">
  </button>

  <button class="btn btn-fs offset-md-1 col-md-10 btn-greengo" (click)="buttonClicked('1')" style="margin-bottom: 1.4rem;" npFocusOutClicked>
    Standard Bank Transfer
    <img src="./assets/images/icon-png/icon-info-white.svg" alt="" [title]="StandardBankTransferTooltip">
  </button>

  <button class="btn btn-fs offset-md-1 col-md-10 btn-greengo-o" (click)="buttonClicked('0')">
    Back
  </button>

</div>